import React from 'react'

const OfferCreateTotalStockQuantity = ({record}) => {

    return(
        <React.Fragment>
            {
                record.data ? record.data.quantity : '-'
            }
        </React.Fragment>
    )
}
export default OfferCreateTotalStockQuantity